import { api } from 'js/modules/axios'
import { computed, ref, watch } from 'vue'
import GLOBAL from 'js/utils/GLOBAL'

// Params da sessionStorage
export const params = ref({})

export const paramsJSON = computed(() => {
  try {
    return JSON.parse(params.value)
  } catch (error) {
    return {}
  }
})

export const paramsString = computed(() =>
  GLOBAL.generateStringFilterFromObject(paramsJSON.value)
)

// Interceptor para remover params globais em requisições marcadas
api.interceptors.request.use(
  function (config) {
    // Se a requisição estiver marcada para ignorar os params globais
    if (config.ignoreGlobalParams) {
      // Remove os params globais desta requisição específica
      const globalParams = paramsJSON.value
      if (config.params) {
        Object.keys(globalParams).forEach((key) => {
          delete config.params[key]
        })
      }
      // Remove a flag para não enviar ao servidor
      delete config.ignoreGlobalParams
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

watch(
  () => params.value,
  (v) => {
    api.defaults.params = {
      ...api.defaults.params,
      ...paramsJSON.value,
    }
  }
)
